import { render, staticRenderFns } from "./base-checkbox.vue?vue&type=template&id=39efe46e&scoped=true&"
import script from "./base-checkbox.vue?vue&type=script&lang=js&"
export * from "./base-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./base-checkbox.vue?vue&type=style&index=0&id=39efe46e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39efe46e",
  null
  
)

export default component.exports